<template>
  <div class="tickets-documents">
    <!-- biglietti e documenti per passeggero (specifico della conferma) -->
    <content-section
      v-if="tickets.length || has_documents"
      title="Biglietti e documenti"
    >
      <b-row class="tickets-documents__wrapper">
        <b-col
          v-for="(traveler, index) in travelers"
          :key="_uid + index"
          class="mb-2"
          md="4"
        >
          <p class="text-size-sm mb-0">Passeggero</p>
          <strong class="semibold mb-1">
            {{ traveler_name(traveler) }}
          </strong>

          <!-- tickets -->
          <div v-if="tickets.length" class="tickets-documents__wrapper">
            <div
              v-for="(ticket, ticket_index) in tickets.filter((t) => {
                return t.travelerId === traveler.id;
              })"
              :key="`sId${_uid}${ticket_index}`"
            >
              <div
                v-for="(
                  ticket_segment, ticket_segment_index
                ) in ticket.segmentIds"
                :key="`s${_uid}tsid${ticket_segment_index}`"
                class="mb-0"
              >
                <div
                  v-for="(
                    itinerary, itinerary_index
                  ) in flight_offer.itineraries"
                  :key="`i${_uid}i${itinerary_index}`"
                >
                  <div
                    v-for="(
                      segment, segment_index
                    ) in itinerary.segments"
                    :key="`i${_uid}s${segment_index}`"
                  >
                    <!-- ckeck per non replicare segmenti in ticket con un solo itinerario-->
                    <div
                      v-if="
                        (flight_offer.itineraries.length === 1 && segment_index === 0) ||
                          flight_offer.itineraries.length > 1
                      "
                    >
                      <div v-if="segment.id === ticket_segment">
                        <!--ticket_segment: {{ ticket_segment }}-->
                        <div
                          v-if="ticket.documentType === 'ETICKET'"
                          class="mt-1"
                        >
                          <div class="d-flex align-center">
                            <div class="mr-2">
                              <b-badge variant="cta">
                                {{ ticket.documentType }}
                              </b-badge>
                            </div>
                            <div class="d-flex mr-1">
                              <div>
                                {{ itinerary.segments[0].departure.iataCode }}
                              </div>
                              <div class="mx-1">-</div>
                              <div class="mr-1">
                                {{ itinerary.segments[itinerary.segments.length - 1].arrival.iataCode }}
                              </div>
                              <div>
                                ({{ reverse_date( itinerary.segments[0].departure.at,) }})
                              </div>
                            </div>
                          </div>

                          <!-- status and services by segment -->
                          <div
                            class="pl-2"
                            :set_traveler_pricing="
                              traveler_pricing =
                                flight_offer.travelerPricings.filter(
                                  (t) => {
                                    return t.travelerId === traveler.id;
                                  },
                                )[0]
                            "
                          >
                            <div>
                              <small
                                class="mr-1"
                              >Ticket number:
                                {{ ticket.documentNumber }}</small>
                              <b-badge
                                :variant="
                                  ticket.documentStatus === 'ISSUED'
                                    ? 'success'
                                    : 'warning'
                                "
                              >
                                {{ ticket.documentStatus }}
                              </b-badge>
                            </div>

                            <div
                              :set_fare_details_by_segment="
                                fare_details_by_segment = (
                                  traveler_pricing.fareDetailsBySegment ||
                                  []
                                ).filter((f) => {
                                  return f.segmentId === segment.id;
                                })[0]
                              "
                            ></div>
                            <template v-if="fare_details_by_segment">
                              <div
                                v-if="
                                  fare_details_by_segment.includedCheckedBags
                                "
                              >
                                <small>Included checked bags:
                                  {{
                                    fare_details_by_segment
                                      .includedCheckedBags.quantity
                                  }}</small>
                              </div>
                              <div
                                v-if="
                                  fare_details_by_segment.mealServices
                                "
                              >
                                <div
                                  v-for="(
                                    meal_service, meal_service_index
                                  ) in fare_details_by_segment.mealServices"
                                  :key="`ms${meal_service_index}`"
                                >
                                  <small>Meal services: "{{
                                    meal_service.label
                                  }}"</small>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                        <div
                          v-if="ticket.documentType === 'EMD'"
                          class="mt-1"
                        >
                          <div class="d-flex align-center">
                            <div class="mr-2">
                              <b-badge variant="primary">
                                {{
                                  ticket.documentType
                                }}
                              </b-badge>
                            </div>
                            <div class="d-flex mr-2">
                              <div>
                                {{
                                  itinerary.segments[0].departure
                                    .iataCode
                                }}
                              </div>
                              <div class="mx-1">-</div>
                              <div class="mr-1">
                                {{
                                  itinerary.segments[
                                    itinerary.segments.length - 1
                                  ].arrival.iataCode
                                }}
                              </div>
                              <div>
                                ({{
                                  reverse_date(
                                    itinerary.segments[0].departure.at,
                                  )
                                }})
                              </div>
                            </div>
                          </div>
                          <div class="pl-2">
                            <div class="mr-2">
                              <div>
                                <small
                                  class="mr-1"
                                >Ticket number:
                                  {{ ticket.documentNumber }}</small>
                                <b-badge
                                  :variant="
                                    ticket.documentStatus === 'ISSUED'
                                      ? 'success'
                                      : 'warning'
                                  "
                                >
                                  {{ ticket.documentStatus }}
                                </b-badge>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="traveler.documents">
            <p class="text-size-sm mb-0">Documento</p>
            <p class="text-size-lg">
              <span
                v-for="(document, index_document) in traveler.documents"
                :key="_uid + index_document"
                class="d-block"
              >
                Numero: {{ document.number }} - Scadenza:
                {{ document.expiryDate }}
              </span>
            </p>
          </div>
        </b-col>
      </b-row>
    </content-section>
  </div>
</template>

<script>
import { reverse_date } from "@/utilities/commons";
import { traveler_name } from "@liveflight/utilities";
import ContentSection from "@liveflight/components/blocks/wrappers/content-section.vue";

export default {
  name: "tickets-documents",

  components: {
    "content-section": ContentSection,
  },

  props: {
    // elenco passeggeri (shape order-body Amadeus)
    travelers: {
      type: Array,
      default: () => [],
    },
    // biglietti emessi (ETICKET/EMD)
    tickets: {
      type: Array,
      default: () => [],
    },
    // offerta di volo da cui leggere itinerari e travelerPricings
    flight_offer: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    // il pannello si mostra solo se c'è almeno un biglietto emesso o un
    // passeggero con documento associato
    has_documents() {
      return this.travelers.some(
        (traveler) => (traveler.documents || []).length,
      );
    },
  },

  created() {
    this.reverse_date = reverse_date;
    this.traveler_name = traveler_name;
  },
};
</script>

<style lang="scss">

.tickets-documents {

  &__wrapper {
    margin-top: $grid-gutter-width / 2;
  }

}
</style>